<template>
  <Walkthrough 
    roomName="Voiture"
    roomKey="car"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="french"
  />
</template>
<script>

export default {
  name: 'Car',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/car-1920x1280.jpg",
      steps: [
        "Regardez à droite et inspectez le siège. Vous devriez trouver un tournevis.",
        "Regardez vers le haut et utilisez votre tournevis sur l’ampoule. Après avoir dévissé l’ampoule, vous devriez trouver un couteau à l'intérieur.",
        "Regardez en bas et utilisez votre couteau sur la ceinture de sécurité. Cela devrait vous libérer et vous permettre de vous déplacer librement vers l'avant de la voiture.",
        "Regardez à gauche et inspectez le porte-gobelet. On dirait que quelqu'un a fait une erreur et t'a laissé une clé.",
        "Regardez vers l'avant, puis utilisez votre tournevis sur le tableau de bord. Cela devrait enlever le tableau de bord et révéler un tas de fils.",
        "Toujours en regardant vers l'avant, utilisez la clé de la boîte à gants. Ceci devrait la déverrouiller et vous devriez trouver un peu de ruban électrique et du texte sur le manuel à l'intérieur.",
        "En utilisant le message contenu dans le manuel, vous savez quels câbles ne pas utiliser. Rappelez-vous ceci. ",
        "Maintenant que vous avez les couleurs pour connecter les fils électriques, utilisez le ruban isolant et connectez les fils vert, orange, noir et bleu. Le courant devrait revenir dans la voiture !",
        "Regardez en bas et inspectez le tapis. Notez que la plaque d'immatriculation que vous trouverez a des chiffres romains 2415. C'est le code du coffre-fort !",
        "En regardant vers l'avant, entrez le code 2415 dans le coffre-fort et quand il s'ouvre, vous devriez trouver une masse à l'intérieur.",
        "Utilisez la masse sur le pare-brise pour l'ouvrir et vous échapper vers la liberté ! Essayez de fuir la pièce voisine par vos propres moyens !"
       ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/walkthrough/fr/car.vue